import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { trackEvent } from '@lib/analytics'

export function usePageTracking() {
	const location = useLocation()

	useEffect(() => {
		trackEvent('page_viewed', {
			path: location.pathname,
			search: location.search || undefined,
		})
	}, [location.pathname, location.search])
}
